"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesforceProductCode = exports.SalesforceBillingCycle = exports.SalesforceBillingType = void 0;
var SalesforceBillingType;
(function (SalesforceBillingType) {
    SalesforceBillingType["CreditCard"] = "Credit Card";
    SalesforceBillingType["InvoiceNet30"] = "Invoice - Net 30";
    SalesforceBillingType["InvoiceNet45"] = "Invoice - Net 45";
    SalesforceBillingType["InvoiceNet60"] = "Invoice - Net 60";
    SalesforceBillingType["InvoiceNet90"] = "Invoice - Net 90";
})(SalesforceBillingType || (exports.SalesforceBillingType = SalesforceBillingType = {}));
var SalesforceBillingCycle;
(function (SalesforceBillingCycle) {
    SalesforceBillingCycle["Monthly"] = "Monthly";
    SalesforceBillingCycle["Annual"] = "Annual";
    SalesforceBillingCycle["Annually"] = "Annually";
    SalesforceBillingCycle["Quarterly"] = "Quarterly";
    SalesforceBillingCycle["Once"] = "Once";
})(SalesforceBillingCycle || (exports.SalesforceBillingCycle = SalesforceBillingCycle = {}));
var SalesforceProductCode;
(function (SalesforceProductCode) {
    SalesforceProductCode["SFSTD001"] = "SFSTD001";
    SalesforceProductCode["SFADV001"] = "SFADV001";
    SalesforceProductCode["SFPREM001"] = "SFPREM001";
    SalesforceProductCode["RSPREM001"] = "RSPREM001";
    SalesforceProductCode["SFVDR001"] = "SFVDR001";
    SalesforceProductCode["RSADVKBA001"] = "RSADVKBA001";
    SalesforceProductCode["SFSTD002"] = "SFSTD002";
    SalesforceProductCode["SFADV002"] = "SFADV002";
    SalesforceProductCode["SFCONNECT002"] = "SFCONNECT002";
    SalesforceProductCode["SF500GB"] = "SF500GB";
    SalesforceProductCode["RSADDON001"] = "RSADDON001";
    SalesforceProductCode["SF3TB"] = "SF3TB";
    SalesforceProductCode["RSVDR001"] = "RSVDR001";
    SalesforceProductCode["PPLUS001"] = "PPLUS001";
    SalesforceProductCode["PPREM001"] = "PPREM001";
    SalesforceProductCode["SFIA001"] = "SFIA001";
})(SalesforceProductCode || (exports.SalesforceProductCode = SalesforceProductCode = {}));
//# sourceMappingURL=salesforceOrder.js.map